import * as glMatrix from 'gl-matrix';
import * as glMatrixAddon from './gl-matrix-addon';
import * as math from './math';
import * as canvas from './canvas';
import BinaryStream from './binarystream';
import BitStream from './bitstream';
import urlWithParams from './urlwithparams';
import * as path from './path';
import { isPng, isJpeg, isGif, isWebP } from './isformat';

export default {
  glMatrix,
  glMatrixAddon,
  math,
  canvas,
  BinaryStream,
  BitStream,
  urlWithParams,
  path,
  isPng,
  isJpeg,
  isGif,
  isWebP,
};
